import React from 'react';
import {Modal} from "../../../../../components/modal/modal.jsx";
import {TransformComponent, TransformWrapper} from "react-zoom-pan-pinch";
const API_URL = import.meta.env.VITE_API_URL;

const ModalPassage = ({show, setShow, passage, plate, sideImage}) => {
    return (
        <Modal className={"w-[57%]"} open={show} setOpen={setShow} title={
            <div className="w-full flex justify-center items-center gap-2 text-center">
                <img src={`${API_URL}/public/assets/img/sentry_lane/${passage?.lane.type}.png`}
                     alt="Lane Type"/>
                <span dangerouslySetInnerHTML={{ __html: passage?.lane.name }} />
            </div>
        }>
            <Modal.Body className="pt-2 pb-2">
                <div className="text-center mb-[3px] vehicle-date-passage">
                    {passage.captureTime}
                </div>
                <div className="product-imitation flex flex-col items-center w-full">
                    <TransformWrapper
                        wrapperClass="w-full flex justify-center items-center"
                        contentClass="w-full flex justify-center items-center"
                    >
                        <TransformComponent>
                            <img
                                src={`${API_URL+ "/" + sideImage}`}
                                className="img-passage w-full h-full object-contain mx-auto block"
                                alt="Passagem"
                            />
                        </TransformComponent>
                    </TransformWrapper>

                    <div className="flex justify-around product-desc mt-2 w-full">
                        <div className="vehicle-plate">
                            <div className={`product-heading ${passage?.plate.pattern ?? 'WITHOUT_PATTERN'}`}></div>
                            <div className={`product-body ${passage?.plate.pattern ?? 'WITHOUT_PATTERN'}`}>
                                {plate}
                            </div>
                        </div>
                    </div>
                </div>

            </Modal.Body>
        </Modal>
    );
};

export default ModalPassage;